// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3Yf3D","container":"styles_container__1W22x","title":"styles_title__3yszF","wrapper":"styles_wrapper__16qeY","answer":"styles_answer__2Rnrt"};